import {MailingList} from "../../Interfaces/MailingList";
import {useUsersListsContext} from "./UsersListsContext.hook";

export type UsersListsContextState = {
    loaded: boolean,
    lists: Array<MailingList>,
}

export type UsersListsContext = ReturnType<typeof useUsersListsContext>;

/////////////////////////////////////////////////////// REDUCER ///////////////////////////////////////////////////////

export enum UsersListsContextDispatchMessageType {
    SetLists, SetLoaded, AddUpdateUsersList, DeleteUsersList
}

type SetList = {
    type: UsersListsContextDispatchMessageType.SetLists,
    lists: Array<MailingList>
};

type SetLoaded = {
    type: UsersListsContextDispatchMessageType.SetLoaded,
    value: boolean,
}

type AddUpdateUsersList = {
    type: UsersListsContextDispatchMessageType.AddUpdateUsersList,
    list: MailingList
}

type DeleteUsersList = {
    type: UsersListsContextDispatchMessageType.DeleteUsersList,
    id: string,
}

export type UsersListsContextDispatchMessage =
    SetList |
    SetLoaded |
    AddUpdateUsersList |
    DeleteUsersList